import { useQuery } from 'react-query';
import { businessTypesUrl, fetchBusinessTypes } from '@general/api/businessTypesAPI';

const useBusinessTypes = () => {
    return useQuery(businessTypesUrl, fetchBusinessTypes(), {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });
};

export default useBusinessTypes;
